import request from '@/utils/request'

// 锦旗详情
export function pennantRewardDetail(data) {
  return request({
    url: '/health-evaluation/evaluation/pennantRewardRecord/detail',
    method: 'get',
    params: data
  })
}
